import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import QuestionHeader from './QuestionHeader';
import classNames from 'classnames';

const YEAR_SPAN = 100;

function parseDateValue(value) {
  if (!value) {
    return null;
  }

  const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (isoMatch) {
    const [, year, month, day] = isoMatch.map(Number);
    const parsed = new Date(year, month - 1, day);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}

function toInputValue(value) {
  const parsed = parseDateValue(value);
  if (!parsed) {
    return '';
  }

  const year = parsed.getFullYear();
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const day = String(parsed.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function formatDateValue(date) {
  return date.toLocaleDateString('en-US');
}

function getDateBounds() {
  const currentYear = new Date().getFullYear();

  return {
    min: `${currentYear - YEAR_SPAN}-01-01`,
    max: `${currentYear + 10}-12-31`,
  };
}

export default class QuestionDate extends PureComponent {
  static propTypes = {
    text: PropTypes.string,
    id: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onIncomplete: PropTypes.func.isRequired,
    onAnswer: PropTypes.func.isRequired,
    required: PropTypes.bool.isRequired,
    answer: PropTypes.shape({
      value: PropTypes.string,
      valueType: PropTypes.string,
    }),
    disabled: PropTypes.bool,
    isAnswerType: PropTypes.bool,
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    text: '',
    answer: {
      value: '',
      valueType: 'string',
    },
    disabled: false,
    isAnswerType: false,
    readOnly: false,
  };

  state = {
    value: this.props.answer.value,
  };

  componentDidMount() {
    const { onAnswer, id, onComplete, required } = this.props;
    const { value } = this.state;
    if (value === '') {
      onAnswer(id, {});
      if (!required) {
        onComplete();
      }
    }
  }

  handleChange = ({ target: { value: inputValue } }) => {
    const { onAnswer, id, onComplete, onIncomplete, required } = this.props;
    const value = inputValue
      ? formatDateValue(parseDateValue(inputValue))
      : '';

    onAnswer(id, { value, valueType: 'date' });
    this.setState({ value });
    if (required && isEmpty(value)) {
      onIncomplete();
    } else {
      onComplete();
    }
  };

  render() {
    const { text, descriptor, disabled, isAnswerType, readOnly, id } = this.props;
    const { value } = this.state;
    const { min, max } = getDateBounds();
    const inputId = `question-date-${id}`;

    return (
      <div className="ma3 w-80 center">
        <p
          className={classNames('b f5', isAnswerType ? 'tl' : 'tc')}
          style={{ overflowWrap: 'break-word' }}
        >
          <QuestionHeader
            linkId={id}
            text={text}
            descriptor={descriptor}
            isAnswerType={isAnswerType}
            readOnly={readOnly}
          />
        </p>
        <div
          className="questionnaire-date-picker mt3"
          onClick={(e) => e.stopPropagation()}
        >
          <label className="questionnaire-date-input-label db f6 b" htmlFor={inputId}>
            Select date
            <input
              id={inputId}
              type="date"
              className="questionnaire-date-input db mt1 w-100 pa2"
              aria-label={`Select date for ${text}`}
              value={toInputValue(value)}
              min={min}
              max={max}
              disabled={disabled || readOnly}
              onChange={this.handleChange}
            />
          </label>
        </div>
      </div>
    );
  }
}
